var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6245 18.6047L20.8401 19.3772C20.8401 19.3772 18.9756 21.2136 13.8864 16.2011C8.79731 11.1889 10.6617 9.35264 10.6617 9.35264L11.1557 8.86614C12.3726 7.66768 12.4873 5.74356 11.4256 4.33888L9.25393 1.46549C7.93991 -0.273084 5.40081 -0.502748 3.89471 0.980589L1.19152 3.64295C0.444726 4.37846 -0.0557169 5.3319 0.00497411 6.38958C0.160232 9.09548 1.39622 14.9175 8.29311 21.7101C15.6069 28.9134 22.4695 29.1997 25.2758 28.9405C26.1635 28.8587 26.9354 28.4109 27.5574 27.7981L30.004 25.3887C31.6554 23.7621 31.1898 20.9737 29.0768 19.836L25.7865 18.0643C24.399 17.3173 22.7089 17.5367 21.6245 18.6047Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3df5c6e9df091852b137c173759fe836.svg";
export { ForwardRef as ReactComponent };